import numeral from 'numeral';

export const BET_TYPES = {
    '-1': '1X2',
    '0': 'AHDP',
    '1': 'O/U',
    '-2': 'Special Multiple',
}

export  function formatAmount(value) {
  let sign = 0 > value ? '-' : '';
  value = parseFloat((Math.abs(value)).toFixed(4));
  let count = (value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0);

  switch (count) {
  case 0:
    value = sign + value + '.00';
    break;
  case 1:
    value = sign + value + '0';
    break;
  default:
    value = sign + value;
    break;
  }
  let components = value.toString().split('.');
  components[0] = components[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return components.join('.');
}

export function makeBetOverviewListing(payload) {
  let betOverviewListing = new BetOverviewListing();

  let betOverview = {};
  let total = {};

  for (let key in payload.betOverview) {
    let row = payload.betOverview[key];

    if (row === null) {
      continue;
    }

    betOverview[key] = {
      averageOdds: formatAmount(row.averageOdds),
      betType: BET_TYPES[row.betType + ""],
      lossCount: row.lossCount,
      numberOfBets: row.numberOfBets,
      profit: formatAmount(row.profit),
      pushCount: row.pushCount,
      turnover: formatAmount(row.turnover),
      validTurnover: formatAmount(row.validTurnover),
      voidCount: row.voidCount,
      winCount: row.winCount,
      yield: formatAmount(row.profit / row.turnover * 100)
    };
  }

  for (let key in payload.total) {
    let row = payload.total;

    total = {
      averageOdds: formatAmount(row.averageOdds),
      betType: row.betType,
      lossCount: row.lossCount,
      numberOfBets: row.numberOfBets,
      profit: formatAmount(row.profit),
      pushCount: row.pushCount,
      turnover: formatAmount(row.turnover),
      validTurnover: formatAmount(row.validTurnover),
      voidCount: row.voidCount,
      winCount: row.winCount,
      yield: formatAmount(row.profit / row.turnover * 100)
    };
  }

  betOverviewListing.betOverview =  betOverview;
  betOverviewListing.total = total;
  
  return betOverviewListing;
}

// Just a reduce callback function
export function makeLeagues(accumulator, league) {
    accumulator[league.id] = league.name;

    return accumulator;
}

export class BetOverviewListing {
  constructor() {
    this._betOverview = {};
    this._total = {};
  }

  set betOverview(betOverview) {
    this._betOverview = betOverview;
  }

  get betOverview() {
    return this._betOverview;
  }

  set total(total) {
    this._total = total;
  }

  get total() {
    return this._total;
  }
}



// WEBPACK FOOTER //
// ./client/app/api/models/overview.model.js